import { Widget } from "@foretagsplatsen/widgetjs";

/**
 * `ListAndIconViewSwitch` is a duo of radio buttons used to switch between
 * a widget view (default) and a list view.
 *
 * @param {function} onListView - Callback performed when view is switched to list mode
 * @param {function} onWidgetView - Callback performed when view is switched to widget mode
 * @param {function} isDefaultViewActive - Function used to determine which
 *   view is active
 * @param {boolean} [defaultsToList] - If true, the list button will be
 *   selected by default
 */
export default class ListAndIconViewSwitch extends Widget {
	constructor({
		onListView,
		onWidgetView,
		isDefaultViewActive,
		defaultsToList,
	}) {
		super(...arguments);

		this._onListView = onListView;
		this._onWidgetView = onWidgetView;
		this._isDefaultViewActive = isDefaultViewActive;
		// We need a strict boolean to compare with the result of isDefaultViewActive
		this._defaultsToList = Boolean(defaultsToList);
	}

	renderContentOn(html) {
		html.div(
			{
				klass: "btn-group desktop-only",
				role: "group",
				"aria-label": "switcher",
			},
			this._renderListButtonOn.bind(this),
			this._renderWidgetButtonOn.bind(this),
		);
	}

	_renderWidgetButtonOn(html) {
		html.button(
			{
				klass: [
					"btn",
					"btn-default",
					{ active: this._isWidgetViewActive() },
				],
				type: "button",
				click: () => this._onWidgetButtonClicked(),
				"data-test": "show-card-grid",
			},
			html.i({ klass: "fa fa-th" }),
		);
	}

	_renderListButtonOn(html) {
		html.button(
			{
				klass: [
					"btn",
					"btn-default",
					{ active: !this._isWidgetViewActive() },
				],
				type: "button",
				click: () => this._onListButtonClicked(),
				"data-test": "show-list-grid",
			},
			html.i({ klass: "fa fa-list" }),
		);
	}

	_isWidgetViewActive() {
		return this._defaultsToList !== this._isDefaultViewActive();
	}

	_onWidgetButtonClicked() {
		if (this._isWidgetViewActive()) return;
		this._onWidgetView();
		this.update();
	}

	_onListButtonClicked() {
		if (!this._isWidgetViewActive()) return;
		this._onListView();
		this.update();
	}
}
